import gql from 'graphql-tag'

export default gql(`
	query getPriceLevelsFA {
		fakturaAssist {
			getFA_Config {
				articlePriceCategory
			}
		}
	}
`)
